//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import FileId from '@models/FileId';
import { ORDERED_INPUT_NAMES } from '@tiktok/components/like2buy/customizations/storeCustomizationsConstants';

export interface ITikTokLike2BuyCustomizationsState {
  customizations: ITikTokLike2BuyCustomizations;
  invalidInputs: typeof ORDERED_INPUT_NAMES[number][];

  isStoreCustomizationsModalOpen: boolean;
  isStorePreviewModalOpen: boolean;

  errors: {
    createCrawledProductError: string | undefined;
    digestBannerImageError: string | undefined;
    updateStoreConfigurationError: string | undefined;
  };
  flags: {
    isCreatingCrawledProduct: boolean;
    isDigestingBannerImage: boolean;
    isUpdatingStoreConfiguration: boolean;
  };
}

interface ITikTokLike2BuyTextCustomization {
  text: string;
  validationError?: string;
}

export interface ITikTokLike2BuyCustomizations {
  banner: {
    altText: ITikTokLike2BuyTextCustomization;
    crawlId?: string;
    destinationUrl: ITikTokLike2BuyTextCustomization;
    imageUpload: {
      imageFileName?: string;
      imageFileId?: FileId;
      validationError?: string;
    };
    isBannerEnabled: boolean;
  };
  ctas: {
    galleryHeader: ITikTokLike2BuyTextCustomization;
    galleryMediaHover: ITikTokLike2BuyTextCustomization;
    productsContainer: ITikTokLike2BuyTextCustomization;
  };
  emailCapture: {
    cta: ITikTokLike2BuyTextCustomization;
    isEnabled: boolean;
    shouldRequireTermsAndConditions: boolean;
    termsAndConditionsUrl: ITikTokLike2BuyTextCustomization;
  };
}

export const DEFAULT_CTA_CUSTOMIZATIONS: ITikTokLike2BuyCustomizations['ctas'] =
  {
    galleryHeader: {
      text: '',
    },
    galleryMediaHover: {
      text: '',
    },
    productsContainer: {
      text: '',
    },
  };

export const DEFAULT_BANNER_CUSTOMIZATIONS: ITikTokLike2BuyCustomizations['banner'] =
  {
    altText: {
      text: '',
    },
    destinationUrl: {
      text: '',
    },
    imageUpload: {},
    isBannerEnabled: false,
  };

export const DEFAULT_EMAIL_CAPTURE_CUSTOMIZATIONS: ITikTokLike2BuyCustomizations['emailCapture'] =
  {
    cta: {
      text: '',
    },
    isEnabled: false,
    shouldRequireTermsAndConditions: false,
    termsAndConditionsUrl: {
      text: '',
    },
  };
